import { Component, Input } from "@angular/core";

@Component({
    selector: "circ-general-error",
    templateUrl: "./general-error.component.html",
    styleUrls: ["./general-error.component.scss"],
    standalone: false
})
export class GeneralErrorComponent {
  @Input() messages: string[] = ["error.fatal"];
}
